export function fetch(id) { return { type: 'OFFERS/FETCH', id } }
export function fetch_one(id) { return { type: 'OFFER/FETCH', id } }
export function archive(id, IdProperty) { return { type: 'OFFER/ARCHIVE', id, IdProperty } }
export function toggle(id, IsActive) { return { type: 'OFFER/TOGGLE', id, IsActive } }
export function clean() { return { type: 'OFFER/CLEAR' } }